import { create } from 'zustand';

const useStoreReports = create((set) => ({
  searchFilterValue: '',
  setSearchFilterValue: (val) => set({ searchFilterValue: val}),
   
}));
export default useStoreReports;
